import { useCallback, useMemo, useState } from 'react';

function areIdSelectionsEqual(a = [], b = []) {
  if (a.length !== b.length) return false;
  const setB = new Set(b.map(String));
  return a.every(id => setB.has(String(id)));
}

export default function useAppliedAgencySelection(selectedOptions) {
  const [appliedOptions, setAppliedOptions] = useState([]);

  const isDirty = useMemo(
    () =>
      !areIdSelectionsEqual(
        selectedOptions.map(o => String(o.value)),
        appliedOptions.map(o => String(o.value))
      ),
    [selectedOptions, appliedOptions]
  );

  const apply = useCallback(
    () => setAppliedOptions(selectedOptions),
    [selectedOptions]
  );

  const markApplied = useCallback(opts => setAppliedOptions(opts), []);

  return { appliedOptions, isDirty, apply, markApplied };
}
